var toLowerCase = function (value) { return "".concat(value).toLowerCase(); };
var filterDropdownList = function (dropdownList, searchAttributes, inputValue, searchMatcher) {
    var filter = searchMatcher
        ? searchMatcher(inputValue, searchAttributes)
        : function (item) {
            return searchAttributes
                .map(function (searchAttribute) { return toLowerCase(item[searchAttribute]); })
                .some(function (cleanItemAttribute) {
                return cleanItemAttribute.includes(toLowerCase(inputValue));
            });
        };
    return dropdownList.filter(filter);
};
export var getListToRender = function (_a) {
    var inputValue = _a.inputValue, searchAttributes = _a.searchAttributes, maxRenderedDropdownElements = _a.maxRenderedDropdownElements, dropdownList = _a.dropdownList, noMatchDropdownList = _a.noMatchDropdownList, searchMatcher = _a.searchMatcher, showAllItemsInDropdown = _a.showAllItemsInDropdown;
    var trimmedInput = inputValue ? String(inputValue).trim() : '';
    var shouldFilter = trimmedInput.length > 0;
    var dropdownListFiltered = shouldFilter
        ? filterDropdownList(dropdownList, searchAttributes, trimmedInput, searchMatcher).slice(0, maxRenderedDropdownElements)
        : dropdownList === null || dropdownList === void 0 ? void 0 : dropdownList.slice(0, maxRenderedDropdownElements);
    var listToRender = function () {
        if (showAllItemsInDropdown) {
            return dropdownList;
        }
        else if (dropdownListFiltered === null || dropdownListFiltered === void 0 ? void 0 : dropdownListFiltered.length) {
            return dropdownListFiltered;
        }
        else if (noMatchDropdownList) {
            return noMatchDropdownList;
        }
        return [];
    };
    return {
        listToRender: listToRender(),
        noMatch: !(dropdownListFiltered === null || dropdownListFiltered === void 0 ? void 0 : dropdownListFiltered.length),
    };
};
